import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './components/admin/admin.component';
import { MapComponent } from './components/map/map.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: '',
    component: MapComponent
  },
  {
    path: 'sirse',
    component: MapComponent,
    data: { tipologia : 'Servizi educativi per l\'infanzia'}
  },
  {
    path: 'assa',
    component: MapComponent,
    data: { tipologia : 'Strutture socio assistenziali'}
  },
  {
    path: environment.adminUrl,
    component: AdminComponent,
  },
  {
    path: '**',
    component: MapComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
